<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div>
      <div class="col-lg-12 ls-no-padding ls-display-flex align-items-stretch flex-wrap-wrap" v-if="Object.keys(contract).length > 0">
        <div class="col-xlg-4 col-lg-5 ls-display-flex">
          <div class="ls-box ls-sm-space ls-lg-margin-bottom ls-display-flex flex-wrap-wrap align-content-between">
            <h4 class="ls-title-4">{{ $t('contracts.show.contract_information') }}</h4>
            <div class="ls-clearfix ls-md-margin-bottom"></div>
            <div class="row ls-display-flex flex-wrap-wrap">
              <label class="ls-label col-xs-6 col-xlg-6 col-lg-6 ls-no-margin">
                <b class="ls-label-text ls-text-md">{{ $t('contracts.show.identifier') }}</b>
                <p class="ls-text-md">{{ contract.id }}</p>
              </label>
              <label class="ls-label col-xs-6 col-xlg-6 col-lg-6 ls-no-margin">
                <b class="ls-label-text ls-text-md">{{ $t('contracts.attributes.code') }}</b>
                <p class="ls-text-md">{{ contract.code }}</p>
              </label>
              <label class='ls-label col-xs-6 col-xlg-6 col-lg-6 ls-no-margin'>
                <b class="ls-label-text ls-text-md">{{ $t('contracts.show.status') }}</b>
                <p class='ls-text-md status' :class="contract.status">{{ $t('contracts.attributes.statuses.' + contract.status) }}</p>
              </label>
              <label class="ls-label col-lg-6 ls-no-margin">
                <b class="ls-label-text ls-text-md">{{ $t('contracts.show.due_date') }}</b>
                <p class="ls-text-md">{{ contract.day_expiration }}</p>
              </label>
              <label v-if="getCpf()" class="ls-label col-xs-6 col-xlg-6 col-lg-8 ls-no-margin">
                <b class="ls-label-text ls-text-md">{{ $t('contracts.show.contract') }}</b>
                <p class="ls-text-md">{{ subscriptionDate() }}</p>
              </label>
              <label class="ls-label col-xs-6 col-xlg-6 col-lg-8 ls-no-margin">
                <b class="ls-label-text ls-text-md">{{ $t('contracts.show.charge_type') }}</b>
                <p class="ls-text-md">{{ $t('contracts.attributes.charge_types.' + chargeType()) }}</p>
              </label>
            </div>
            <h4 class="ls-title-4 ls-md-margin-top">{{ $t('contracts.show.client') }}</h4>
            <div class="ls-clearfix ls-md-margin-bottom"></div>
            <div class="row ls-display-flex flex-wrap-wrap">
              <label class="ls-label col-lg-6 col-xs-6 col-xlg-6 ls-no-margin">
                <b class="ls-label-text">{{ $t('contracts.show.client_type') }}</b>
                <p data-test="contract.customer.type" v-if="contract.customer.kind === 'P'">{{ $t('contracts.show.person') }}</p>
                <p v-else>{{ $t('contracts.show.person_customer') }}</p>
              </label>
              <label class="ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin">
                <b class="ls-label-text">{{ $t('contracts.show.full_name') }}</b>
                <p data-test="contract.customer.name">{{ contract.customer.name }}</p>
              </label>
              <label class="ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin">
                <b class="ls-label-text">{{ $t('contracts.show.mail') }}</b>
                <p data-test="contract.customer.email">{{ contract.customer.email }}</p>
              </label>
              <label v-if="getCpf()" class="ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin">
                <b class="ls-label-text">{{ $t('contracts.show.cpf') }}</b>
                <p data-test="contract.customer.cpf">{{ getCpf() }}</p>
              </label>
              <label v-if="getCode()" class="ls-label col-lg-8 ls-no-margin">
                <b class="ls-label-text">{{ $t('contracts.show.customer_code') }}</b>
                <p data-test="contract.customer.code">{{ getCode() }}</p>
              </label>
              <label v-if="contract.customer.kind === 'C'" class="ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin">
                <b class="ls-label-text">{{ $t('contracts.show.cnpj') }}</b>
                <p data-test="contract.customer.cnpj">{{ getCnpj() }}</p>
              </label>
              <label class="ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin">
                <b class="ls-label-text">{{ $t('contracts.show.phone') }}</b>
                <p data-test="contract.customer.phone">{{ getPhone() }}</p>
              </label>
              <div class="ls-float-right col-xs-6 col-lg-6 col-xlg-6  ls-display-flex align-itens-end">
                <p><router-link class="link" :to="{ name: 'edit_customer', params: { id: contract.customer.id }}" :title="$t('contracts.show.view_client_detail')">{{ $t('contracts.show.view_client_detail') }}<span class="ls-ico-shaft-right ls-xs-margin-left"></span></router-link></p>
              </div>
            </div>
            <div class="ls-md-margin-top" v-if="contract.recurring_payment_with_card">
              <h4 class="ls-title-4 ls-md-margin-bottom">{{ $t('contracts.show.automatic_debit') }}</h4>
              <div class="row ls-display-flex flex-wrap justify-content-center">
                <div class="col-md-4 col-lg-3 col-xlg-2 col-xs-4">
                  <img class="ls-no-padding" v-bind:src="require('../../../assets/img/' + contract.card.payment_method + '-logo.png')">
                </div>
                <div class="col-md-6 col-xlg-6">
                  <b class="ls-label-text font-size-14">{{ contract.card.name }}</b>
                  <p class="font-size-14">{{ contract.card.masked_pan }}</p>
                  <p>{{ $t('contracts.labels.card_expiration' )}}: {{ contract.card.month }}/{{ contract.card.year }}</p>
                </div>
                <div class="col-xs-6 col-md-6 col-lg-12 col-xlg-4 ls-display-flex justify-content-end">
                  <authorized-link tag="inactivate_debit_contract">
                    <button class="ls-btn-primary no-margin ls-no-margin-bottom" @click.prevent="setInactivateAutomaticDebit">
                      <span>{{ $t('contracts.buttons.cancel_debit ')}}</span>
                    </button>
                  </authorized-link>
                </div>
              </div>
            </div>
            <div class="ls-md-margin-top" v-if="contract.recurring_payment_with_balance">
              <h4 class="ls-title-4 ls-md-margin-bottom">{{ $t('contracts.show.automatic_debit_with_yapay') }}</h4>

              <div class="ls-display-flex flex-wrap">
                <div class="col-md-3 col-lg-3 col-xlg-2 col-xs-3">
                  <img class="ls-no-padding" v-bind:src="require('../../../assets/img/logo-yp.svg')">
                </div>
                <div class="col-md-9 col-lg-9 col-xlg-6 ls-display-flex align-items-center ls-no-padding-left">
                  <b class="font-size-14 font-size-18">{{ contract.yapay_account.email_yapay }}</b>
                </div>
                <div class="col-lg-12 col-xs-12 col-md-6 col-xlg-4 ls-display-flex justify-content-end">
                  <authorized-link tag="inactivate_debit_contract">
                    <button class="ls-btn-primary ls-no-margin" @click.prevent="setInactivateAutomaticDebit">
                      <span>{{ $t('contracts.buttons.cancel_debit ') }}</span>
                    </button>
                  </authorized-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-lg-7 col-xlg-8 ls-display-flex align-items-stretch flex-wrap-wrap">
          <div class="ls-box ls-sm-space scroll-y max-height">
            <div class="col-md-12">
              <div class="ls-float-left">
                <h4 class="ls-title-4">{{ $t('contracts.show.plans') }}</h4>
              </div>
              <authorized-link tag="update_contract">
                <div v-if="validStatus()" class="ls-float-right ls-md-margin-left">
                  <router-link class="ls-btn-primary ls-no-margin" slot="button" :to="{name: 'contracts_edit', params: { id: contract.id }}"><i class="fa fa-pencil-square-o" aria-hidden="true"></i><span class="ls-xs-margin-left">{{ $t('contracts.show.edit_subscription') }}</span></router-link>
                </div>
              </authorized-link>
              <modal-log v-bind:id="contract.id"></modal-log>
            </div>
            <table v-if="contract.contract_plans.length" class="ls-table ls-sm-space ls-float-left ls-txt-center fixed_header">
              <thead>
                <tr>
                  <th>{{ $t('contracts.show.description') }}</th>
                  <th>{{ $t('contracts.show.value') }}</th>
                  <th class="hidden-xs">{{ $t('contracts.show.discount')}}</th>
                  <th>{{ $t('contracts.show.charges_made') }}</th>
                  <th>{{ $t('contracts.show.discounts_launched') }}</th>
                  <th>{{ $t('contracts.show.status')}}</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(contract_plan, index) in orderedContractPlans" :key="index">
                <td>{{ contract_plan.plan.name }}</td>
                <td>R$ {{ money.parseViewValue(contract_plan.price) }}</td>
                <td class="hidden-xs">R$ {{ money.parseViewValue(discount(contract_plan))}}</td>
                <td>{{ chargesMade(contract_plan) }}</td>
                <td>{{ discountsLaunched(contract_plan) }}</td>
                <td :class="contract_plan.status === 'active' ? 'active-contract-plan' : 'inactive-contract-plan'"><span class="ls-display-inline-block">{{ $t('contract_plans.attributes.statuses.' + contract_plan.status) }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="ls-box ls-sm-space ls-lg-margin-bottom min-width-100">
            <div class="col-md-12">
              <div class="ls-float-left">
                <h4 class="ls-title-4">{{ $t('contracts.show.invoices') }}</h4>
              </div>
              <authorized-link class="ls-display-block-xs" tag="index_entry">
                <div class="ls-float-right">
                  <button @click="setEntryData()" class="ls-btn-primary ls-no-margin">
                    <span>{{ $t('contracts.show.add_entry') }}</span>
                  </button>
                </div>
              </authorized-link>
              <div class="ls-float-right ls-md-margin-left" v-if="contract.status === 'active'">
                <button @click="setSeparateInvoice()" class="ls-btn-primary ls-xs-margin-rigth-in-md ls-no-margin ls-xs-margin-top-in-sm">
                  <span>{{ $t('contracts.show.separate_invoice') }}</span>
                </button>
              </div>
            </div>
            <div class="ls-clearfix ls-md-margin-bottom"></div>
            <table v-if="invoices.length" class="ls-table ls-txt-center ls-xs-space fixed_header">
              <thead>
                <tr>
                  <th>{{ $t('contracts.show.emission_date') }}</th>
                  <th>{{ $t('contracts.show.value') }}</th>
                  <th>{{ $t('contracts.show.status') }}</th>
                  <th class="ls-display-none-xs">{{ $t('contracts.show.payment_date') }}</th>
                  <th>{{ $t('contracts.show.actions') }}</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(invoice, index) in invoices" v-if="index + 1 <= limitNumber || showAllInvoices" v-bind:class="{'alert-line': contract.pending_payment}">
                <td>
                  {{ date.parseDate(invoice.created_at) }}<br><small>{{ $t('contracts.show.due_date') }}: {{ invoiceDueDate(invoice.due_date) }}</small>
                </td>
                <td>R$ {{ money.parseViewValue(invoice.amount_due) }}</td>
                <td>{{ $t('invoices.attributes.statuses.' + invoice.status) }}</td>
                <td class="ls-display-none-xs">{{ invoicePaymentDate(invoice) }}</td>
                <td class="alignment-by-size">
                  <a slot="button" class="ls-btn ls-no-margin ls-btn-default ls-cursor-pointer ls-float-right" @click="openInvoice(invoice.id)">{{ $t('application.button.detail') }}</a>
                </td>
              </tr>
              </tbody>
            </table>
            <p v-else class="ls-txt-center">{{ $t('invoices.alerts.not_available') }}</p>
            <div class="ls-txt-center">
              <button slot="button" class="ls-btn ls-no-margin" @click="toggleInvoices" v-if="itemsCount > limitNumber">
                <span>{{ $t('contracts.show.show_more_invoices') }}</span>
              </button>
            </div>
          </div>
        </div>
        <modal-inactivate-automatic-debit v-model="inactivateAutomaticDebit"></modal-inactivate-automatic-debit>
        <modal-add-entry v-model="entryObjects" />
        <modal-inactive v-model="inactiveObjects"></modal-inactive>
        <modal-separate-invoice v-model="separateInvoice"></modal-separate-invoice>
      </div>
    </div>
    <button v-if="testEnvironment()" @click="createNextInvoice()" class="ls-btn">Gerar próxima fatura</button>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import ModalAddEntry from '../entries/components/ModalAddEntry'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
  import Regroup from 'src/app/components/shareds/regroup/Regroup'
  import ModalInactive from './components/ModalInactive'
  import ModalLog from './components/ModalLog'
  import ModalInactivateAutomaticDebit from './components/ModalInactivateAutomaticDebit'
  import ModalSeparateInvoice from '../invoices/components/ModalSeparateInvoice'
  import date from 'src/utils/date'
  import money from 'src/utils/money'
  import scroll from 'src/utils/scroll'
  import * as format from 'src/utils/form'

  export default {
    name: 'ShowContracts',
    components: { ModalInactivateAutomaticDebit, ModalAddEntry, Breadcrumb, Dropdown, Regroup, ModalInactive, ModalSeparateInvoice, ModalLog },
    data () {
      return {
        inactiveObjects: { show: false },
        inactivateAutomaticDebit: { show: false },
        orderedContractPlans: [],
        entryObjects: { show: false },
        separateInvoice: { show: false },
        limitNumber: 3,
        error: false,
        date: date,
        money: money,
        showAllInvoices: false,
        crumbs: {
          'ico': 'ls-ico-week',
          'section': this.$t('contracts.show.view_subscription'),
          'paths': {
            0: {
              'title': this.$t('contracts.edit.subscriptions'),
              'path': '/contracts'
            },
            1: {
              'title': this.$t('contracts.show.subscription_detail'),
              'path': ''
            }
          }
        }
      }
    },
    mounted () {
      this.getContract()
    },
    computed: {
      ...mapGetters(['contract', 'invoices', 'entries'])
    },
    methods: {
      ...mapActions(['loadContract', 'loadInvoicesByContract', 'loadEntries', 'generateNextInvoice']),
      ...mapMutations(['setInvoices', 'setInvoice', 'setPageData', 'setPagination', 'clearFlash']),
      today () {
        return date.parseInternationalDate(new Date())
      },
      getCpf () {
        if (this.contract.customer.cpf) {
          return format.cpf(this.contract.customer.cpf)
        }
      },
      getCnpj () {
        return this.contract.customer.cnpj !== null ? format.cnpj(this.contract.customer.cnpj) : '-'
      },
      getCode () {
        return this.contract.customer.code
      },
      getPhone () {
        return this.contract.customer.contact !== null ? format.ddd(this.contract.customer.contact.area_code) + ' ' + format.phone(this.contract.customer.contact.number) : '(00) 0 0000-0000'
      },
      orderContractPlans () {
        return this.contract.contract_plans.sort(function (x, y) {
          if (x.status === 'active' && y.status !== 'active') return -1
          return 1
        })
      },
      itemsCount () {
        return this.invoices.length
      },
      subscriptionDate () {
        return this.contract.status === 'active' ? date.parseDate(this.contract.activated_at) : '-'
      },
      statusClass () {
        var klass = ''
        switch (this.contract.status) {
          case 'pending':
            klass = 'ls-tag-warning'
            break
          case 'active':
            klass = 'ls-tag-primary'
            break
          case 'inactive':
            klass = 'ls-tag-default'
            break
          case 'overdue':
            klass = 'ls-tag-danger'
            break
          case 'canceled':
            klass = 'ls-tag-default'
            break
        }
        return klass
      },
      invoicePaymentDate (obj) {
        return obj.status === 'paid' ? date.parseDate(obj.paid_at) : '-'
      },
      validStatus () {
        return this.contract.status !== 'finished' && this.contract.status !== 'canceled' && this.contract.status !== 'inactive'
      },
      invoiceDueDate (dueDate) {
        var parts = dueDate.split('-')
        dueDate = new Date(parts[0], parts[1] - 1, parts[2])
        return date.parseDate(dueDate)
      },
      getContract () {
        this.$loader.show()
        this.loadContract(this.$route.params.id).then(this.getInvoices)
      },
      getInvoices () {
        this.orderedContractPlans = this.orderContractPlans()
        this.loadInvoicesByContract(this.$route.params).then(this.afterLoad)
      },
      afterLoad () {
        setTimeout(() => { this.$loader.hide() }, 500)
      },
      chargeType () {
        return this.contract.post_paid ? 'post_paid' : 'pre_paid'
      },
      activeContractPlans (contractPlans) {
        let actives = contractPlans.filter(function (contractPlan) {
          if (contractPlan.active === true) {
            return contractPlan
          }
        })
        return actives
      },
      toggleInvoices (event) {
        this.showAllInvoices = !this.showAllInvoices
        if (this.showAllInvoices) {
          event.target.innerHTML = this.$t('contracts.show.hide_invoices')
        } else {
          event.target.innerHTML = this.$t('contracts.show.show_more_invoices', { itens: this.itemsCount })
        }
      },
      discount (contractPlan) {
        let amountDiscount = 0.00
        for (let entry of contractPlan.contract_plan_entries) {
          if (entry.quantity === 0 || entry.quantity > entry.quantity_launched) {
            amountDiscount += parseFloat(entry.price)
          }
        }
        return amountDiscount
      },
      setInactiveData (event) {
        this.clearFlash()
        this.inactiveObjects.show = true
        this.inactiveObjects.callback = scroll.scrollToFlash
      },
      setInactivateAutomaticDebit () {
        this.clearFlash()
        this.inactivateAutomaticDebit.show = true
        this.inactivateAutomaticDebit.callback = scroll.scrollToFlash
      },
      setEntryData () {
        this.getEntries()
        this.clearFlash()
        this.entryObjects.show = true
      },
      setSeparateInvoice () {
        this.clearFlash()
        this.separateInvoice.show = true
      },
      getEntries () {
        var params = { contract_id: this.contract.id, pagination: { per_page: 999, current_page: 1 } }
        this.loadEntries(params)
        this.$loader.hide()
      },
      openInvoice (invoiceId) {
        this.$router.push('/invoices/' + invoiceId)
      },
      scrollToFlashMessage () {
        scroll.scrollToFlash()
      },
      discountsLaunched (contractPlan) {
        if (contractPlan.contract_plan_entries[0] === undefined) return '-'
        if (parseInt(contractPlan.contract_plan_entries[0].quantity) === 0) return 'Recorrente'
        return contractPlan.contract_plan_entries[0].quantity_launched + '/' + contractPlan.contract_plan_entries[0].quantity
      },
      chargesMade (contractPlan) {
        if (parseInt(contractPlan.quantity) === 0 || contractPlan.quantity === undefined || contractPlan.quantity === null) return 'Recorrente'
        return contractPlan.quantity_launched + '/' + contractPlan.quantity
      },
      testEnvironment () {
        return process.env.ENVIRONMENT === 'development' || process.env.ENVIRONMENT === 'test'
      },
      createNextInvoice () {
        this.$loader.show()
        if (!this.testEnvironment()) return

        this.generateNextInvoice(this.$route.params.id).then(this.getContract)
      }
    },
    beforeDestroy () {
      this.setInvoices({})
      this.setPageData({})
      this.setPagination({})
    }
  }
</script>
<style>
  .justify-content-start {
    justify-content: flex-start;
  }
  .justify-content-between {
    justify-content: space-between;
  }
  .align-items-center {
    align-items: center
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .min-width-100 {
    min-width: 100%;
  }
</style>
<style lang="scss" scoped>
  .alert-line {
    background: #f1f1f1;
  }
  .alignment-by-size > * {
    @media (max-width: 1500px) {
      text-align: center !important;
    }
    text-align: left !important;
  }
  .inactive-contract-plan {
    background: #f2f2f2!important;
    color: #8c8c8c;
  }
  .active-contract-plan {
    background-color: #b2e1b3!important;
    color: #388f39;
  }
  .max-height {
   max-height: 400px;
  }
  .show-plans-height {
    height: 100px;
  }
  .scroll-y {
    overflow-y: auto;
  }
  .align-center {
    display: flex;
    align-items: center;
  }
  .text-align-center {
    text-align: center;
  }
  .font-size-14 {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// Show.vue?3a40d850